import React from 'react';
import moment from 'moment';

import icoCharge from 'assets/images/dialogs/ChargeSuccessful.svg';
import { withTranslation } from 'providers/GILT.provider';

import SimpleDialog from 'scheduler/components/SimpleDialog';
import IsOrderedItem from 'stocks/components/OrderReceived/IsOrderedItem';
import OrderItem from 'stocks/components/OrderReceived/OrderItem';
import { mapOrderProducts } from 'stocks/utils';

class Parent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: false,
      isCheckedCb2: false,
      isCheckedCb3: false,
      isOpen: false,
      isBulkImport: false,
      modalDeleteOrder: false,
      modalMarkedAsScanner: false,
      modalConfirmImport: false,
      modalSuccessImport: false,
      modalLeaveOrderDetails: false,
      currProductList: [],
      editedChanges: false,
      isImporting: false,
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.orderProductList) {
      this.setState({
        currProductList: nextProps.orderProductList.productList,
      });
    }

    if (nextProps.orderItem.imported_at !== null && this.state.isImporting) {
      this.setState({
        isImporting: false,
      });
    }
  }

  onToggleOrder = () => {
    this.props.getOrderDetails(this.props.salonId, this.props.orderItem.id);
    this.props.onOpenDetails(this.props.orderItem.id);
    this.setState({ isOpen: !this.state.isOpen, modalLeaveOrderDetails: false, editedChanges: false });
  };

  onPrepareImportClick = () => {
    this.props.getOrderDetails(this.props.salonId, this.props.orderItem.id);
    this.props.onOpenDetails(this.props.orderItem.id);
    this.setState({
      isBulkImport: true,
      isOpen: true,
      editedChanges: false,
      modalLeaveOrderDetails: false,
    });
  };

  onConfirmImport = () => {
    this.setState({ isImporting: true });
    this.props.importBulkOrder(this.props.salonId, this.props.orderItem.id, this.state.currProductList);
    this.setState({ modalConfirmImport: false, isOpen: false, modalSuccessImport: true });
    setTimeout(() => {
      this.setState({ modalSuccessImport: false });
    }, 1000);
  };

  onMarkedClick = () => this.setState({ modalMarkedAsScanner: true });
  onDeleteOrder = () => this.setState({ modalDeleteOrder: true });
  onDeleteOrderRequest = () => {
    this.setState({ modalDeleteOrder: false });
    this.props.deleteOrder(this.props.salonId, this.props.orderItem.id);
  };

  onHidePrepareImport = () => {
    if (this.props.orderItem.imported_at === null && this.props.orderItem.scanned_at === null && this.state.editedChanges) {
      this.setState({ modalLeaveOrderDetails: true });
    } else {
      this.setState({ currProductList: [], isOpen: false, isBulkImport: false, modalLeaveOrderDetails: true });
    }
  };

  onCloseModalHide = () => this.setState({ currProductList: [], isOpen: false, isBulkImport: false, modalLeaveOrderDetails: false });

  onSaveChanges = (editProduct) => {
    const updateState = [];
    this.state.currProductList.forEach((el) => {
      let addItem = el;
      if (el.product.id === editProduct.product.id) {
        addItem = editProduct;
      }
      updateState.push(addItem);
    });
    this.setState({ currProductList: updateState, editedChanges: true });
  };

  markAsReceived = () => {
    this.props.scanOrder(this.props.salonId, this.props.orderItem.id);
    this.setState({ modalMarkedAsScanner: false });
  };

  showModalConfirmImport = () => void this.setState({ modalConfirmImport: true });
  toggleCheckbox = () => this.setState({ isChecked: !this.state.isChecked });
  toggleCheckboxCb2 = () => this.setState({ isCheckedCb2: !this.state.isCheckedCb2 });
  toggleCheckboxCb3 = () => this.setState({ isCheckedCb3: !this.state.isCheckedCb3 });

  render() {
    const { isOpen, isBulkImport, modalDeleteOrder, modalMarkedAsScanner, modalConfirmImport, modalSuccessImport, modalLeaveOrderDetails } = this.state;
    const onRequestClose = () => {
      this.setState({
        modalDeleteOrder: false,
        modalMarkedAsScanner: false,
        modalConfirmImport: false,
        modalLeaveOrderDetails: false,
      });
    };
    const { popUpId, t } = this.props;
    const isMarked = this.props.orderItem.scanned_at !== null ? true : this.props.orderItem.imported_at !== null;
    let brandKeys = [];
    let groupProductItems = null;
    if (this.state.currProductList) {
      groupProductItems = mapOrderProducts(this.state.currProductList);
      if (groupProductItems) {
        brandKeys = Object.keys(groupProductItems).sort((s1, s2) => s1.localeCompare(s2));
      }
    }
    return (
      <div>
        <div className="order-container cfix">
          <div className="order-date">
            {/* TODO: date localisation */}
            <span>{moment(this.props.orderItem.created_at).format('DD MMM YYYY')}</span>
            {isOpen && popUpId === this.props.orderItem.id ? (
              <button className="btn btn-link view-link" onClick={this.onHidePrepareImport}>
                {t('stocks.ordersReceived.hideDetailsBtn')}
              </button>
            ) : (
              <button className="btn btn-link view-link" onClick={this.onToggleOrder}>
                {t('stocks.ordersReceived.viewDetailsBtn')}
              </button>
            )}
          </div>
          <div className="order-id">{this.props.orderItem.number}</div>
          <div className="items-number">{this.props.orderItem.items_ordered}</div>
          {!isBulkImport ? (
            <>
              {!isMarked ? (
                <div className="btn btn-outline mark-as-scanned" onClick={this.onMarkedClick} role="button" tabIndex="0">
                  {t('stocks.ordersReceived.markScannedBtn')}
                </div>
              ) : (
                <div className="text">
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {this.props.orderItem.scanned_at === null
                    ? this.state.isImporting
                      ? t('stocks.ordersReceived.updating')
                      : this.props.orderItem.items_imported
                    : t('stocks.ordersReceived.scannedManually')}
                </div>
              )}
            </>
          ) : (
            <div className="text">
              {/* eslint-disable-next-line no-nested-ternary */}
              {this.props.orderItem.scanned_at === null
                ? this.state.isImporting
                  ? t('stocks.ordersReceived.updating')
                  : this.props.orderItem.items_imported
                : t('stocks.ordersReceived.scannedManually')}
            </div>
          )}
          {modalMarkedAsScanner && (
            <SimpleDialog
              title=" "
              leftButtonText={t('common.buttons.cancel')}
              rightButtonText={t('common.buttons.confirmUpp')}
              onLeft={onRequestClose}
              onRight={this.markAsReceived}
              displayHeader="header-non"
              uniqueClass={`modal-marked-as-scanner ${this.state.isChecked ? '' : 'disable-btn-submit'}`}
              isOpen={modalMarkedAsScanner}
            >
              <div className="dialog-inner-title">{t('stocks.ordersReceived.markScannedDialog.title')}</div>
              <div className="dialog-text">
                <div className="checkbox-box-custom-wrap">
                  <input type="checkbox" className="checkbox-box-custom" id="cb1" checked={this.state.isChecked} onChange={this.toggleCheckbox} />
                  <label className="checkbox-box-label" htmlFor="cb1">
                    <div className="checkbox-box-custom-icon">
                      <span className="ic-sml-18px ic_check_white_18" />
                    </div>
                    <div className="label-text">{t('stocks.ordersReceived.markScannedDialog.checkboxInfo')}</div>
                  </label>
                </div>
              </div>
            </SimpleDialog>
          )}
          {isMarked ? (
            <span className="order-date-received">
              {this.props.orderItem.imported_at
                ? //  TODO: date localisation
                  moment(this.props.orderItem.imported_at).format('DD MMM YYYY')
                : moment(this.props.orderItem.scanned_at).format('DD MMM YYYY')}
            </span>
          ) : (
            <>
              <button className={!isOpen ? 'btn btn-outline bulk-link' : 'btn btn-violet bulk-link'} onClick={!isBulkImport ? this.onPrepareImportClick : this.showModalConfirmImport}>
                {!isOpen ? t('stocks.ordersReceived.bulkImportBtn') : t('stocks.ordersReceived.importReceivedBtn')}
              </button>
            </>
          )}
          {!isMarked ? <div className="delete-order" role="button" tabIndex={0} onClick={this.onDeleteOrder} /> : <div className="delete-order invisible" />}
        </div>
        {isMarked && isOpen && popUpId === this.props.orderItem.id && (
          <>
            {isOpen ? (
              <div className="table-orders-prepare-for-import">
                {groupProductItems !== null &&
                  brandKeys.map((key) => {
                    const brand = groupProductItems[key];
                    const subBrandKeys = Object.keys(brand).sort((s1, s2) => s1.localeCompare(s2));
                    return (
                      <div>
                        <div className="brand-banner">{key}</div>
                        {subBrandKeys.map((subKey) => {
                          const subCategory = brand[subKey];
                          const items = [...Object.values(subCategory)[0]];
                          return (
                            <section className="divider">
                              <div className="item-row item-header">
                                <div className="item-name">{subKey}</div>
                                <div className="item-current-q">{t('stocks.ordersReceived.tableHeaders.quantityOrdered')}</div>
                                <div className="item-q-ordered">
                                  {this.props.orderItem.imported_at ? t('stocks.ordersReceived.tableHeaders.quantityImported') : t('stocks.ordersReceived.tableHeaders.quantityReceived')}
                                </div>
                                <div className="item-q-received" />
                                <div className="item-new-q" />
                                <div className="empty" />
                              </div>
                              {items.map((orderItem) => (
                                <IsOrderedItem
                                  isImported={this.props.orderItem.imported_at !== null}
                                  orderInfo={orderItem}
                                  importedProductInfo={
                                    this.props.orderProductList.imported_productList ? this.props.orderProductList.imported_productList.filter((c) => c.product_id === orderItem.product.id)[0] : null
                                  }
                                />
                              ))}
                            </section>
                          );
                        })}
                      </div>
                    );
                  })}
              </div>
            ) : null}
          </>
        )}
        {!isMarked && isOpen && popUpId === this.props.orderItem.id ? (
          <div className="table-orders-prepare-for-import">
            {groupProductItems !== null &&
              brandKeys.map((key) => {
                const brand = groupProductItems[key];
                const subBrandKeys = Object.keys(brand).sort((s1, s2) => s1.localeCompare(s2));
                return (
                  <div>
                    <div className="brand-banner">{key}</div>
                    {subBrandKeys.map((subKey) => {
                      const subCategory = brand[subKey];
                      const items = [...Object.values(subCategory)[0]];
                      return (
                        <section className="divider">
                          <div className="item-row item-header">
                            <div className="item-name">{subKey}</div>
                            <div className="item-current-q">{t('stocks.ordersReceived.tableHeaders.currentQuantity')}</div>
                            <div className="item-q-ordered">{t('stocks.ordersReceived.tableHeaders.quantityOrdered')}</div>
                            <div className="item-q-received">{t('stocks.ordersReceived.tableHeaders.quantityReceived')}</div>
                            <div className="item-new-q">{t('stocks.ordersReceived.tableHeaders.newQuantity')}</div>
                            <div className="empty" />
                          </div>
                          {items.map((orderItem) => (
                            <OrderItem orderInfo={orderItem} onSaveChanges={this.onSaveChanges} />
                          ))}
                        </section>
                      );
                    })}
                  </div>
                );
              })}
          </div>
        ) : null}
        {modalDeleteOrder && (
          <SimpleDialog
            title=" "
            leftButtonText={t('common.buttons.cancel')}
            rightButtonText={t('common.buttons.deleteUpp')}
            onLeft={onRequestClose}
            onRight={this.onDeleteOrderRequest}
            displayHeader="header-non"
            uniqueClass="wide-btn"
            isOpen={modalDeleteOrder}
          >
            <div className="dialog-inner-title">{t('stocks.ordersReceived.deleteDialog.title')}</div>
            <div className="dialog-text">
              <p>{t('stocks.ordersReceived.deleteDialog.description')}</p>
            </div>
          </SimpleDialog>
        )}
        {modalConfirmImport && (
          <SimpleDialog
            title=" "
            leftButtonText={t('common.buttons.cancel')}
            rightButtonText={t('stocks.ordersReceived.importQuantitiesDialog.confirmButton')}
            onLeft={onRequestClose}
            onRight={this.onConfirmImport}
            displayHeader="header-non"
            uniqueClass={`modal-marked-as-scanner ${this.state.isCheckedCb2 && this.state.isCheckedCb3 ? '' : 'disable-btn-submit'}`}
            isOpen={modalConfirmImport}
          >
            <div className="dialog-inner-title">{t('stocks.ordersReceived.importQuantitiesDialog.title')}</div>
            <div className="dialog-text">
              <div className="checkbox-box-custom-wrap">
                <input type="checkbox" className="checkbox-box-custom" id="cb2" checked={this.state.isCheckedCb2} onChange={this.toggleCheckboxCb2} />
                <label className="checkbox-box-label" htmlFor="cb2">
                  <div className="checkbox-box-custom-icon">
                    <span className="ic-sml-18px ic_check_white_18" />
                  </div>
                  <div className="label-text">{t('stocks.ordersReceived.importQuantitiesDialog.checkbox1Text')}</div>
                </label>
              </div>
              <div className="checkbox-box-custom-wrap">
                <input type="checkbox" className="checkbox-box-custom" id="cb3" checked={this.state.isCheckedCb3} onChange={this.toggleCheckboxCb3} />
                <label className="checkbox-box-label" htmlFor="cb3">
                  <div className="checkbox-box-custom-icon">
                    <span className="ic-sml-18px ic_check_white_18" />
                  </div>
                  <div className="label-text">{t('stocks.ordersReceived.importQuantitiesDialog.checkbox2Text')}</div>
                </label>
              </div>
            </div>
          </SimpleDialog>
        )}
        {modalSuccessImport && (
          <SimpleDialog title=" " leftButtonText="" rightButtonText="" onLeft={() => {}} onRight={() => {}} displayHeader="header-non" uniqueClass="modal-ok-no-footer" isOpen={modalSuccessImport}>
            <div className="dialog-inner-title" />
            <img src={icoCharge} alt="Successful Import" className="dialog-image" />
            <div className="dialog-text text-center text-violet">{t('stocks.ordersReceived.stockQuantitiesUpdatedMsg')}</div>
          </SimpleDialog>
        )}
        {modalLeaveOrderDetails && this.props.orderItem.imported_at === null && this.props.orderItem.scanned_at === null && this.state.editedChanges && (
          <SimpleDialog
            title=" "
            leftButtonText={t('stocks.ordersReceived.backButton')}
            rightButtonText={t('stocks.ordersReceived.confirmButton')}
            onLeft={() => {
              this.setState({ modalLeaveOrderDetails: false });
            }}
            onRight={this.onCloseModalHide}
            displayHeader="header-non"
            uniqueClass="wide-btn"
            isOpen={this.state.modalLeaveOrderDetails}
          >
            <div className="dialog-inner-title">{t('stocks.ordersReceived.leaveOrderDetailsDialog.title')}</div>
            <div className="dialog-text">
              <p>{t('stocks.ordersReceived.leaveOrderDetailsDialog.description')}</p>
            </div>
          </SimpleDialog>
        )}
      </div>
    );
  }
}

const ParentHoc = withTranslation()(Parent);
export default ParentHoc;
